import type { EntityConfig } from '../types'

export const posInventoryEntity: EntityConfig = {
  id: 'pos-inventory',
  displayName: 'POS Inventory',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'critical', label: 'Critical' },
      { value: 'low', label: 'Low Stock' },
      { value: 'good', label: 'In Stock' },
      { value: 'overstocked', label: 'Overstocked' },
    ],
    options: [
      { value: 'critical', label: 'Critical', color: 'error' },
      { value: 'low', label: 'Low', color: 'warning' },
      { value: 'good', label: 'Good', color: 'success' },
      { value: 'overstocked', label: 'Overstocked', color: 'info' },
    ],
    mappings: {
      all: ['critical', 'low', 'good', 'overstocked'],
      critical: ['critical'],
      low: ['low'],
      good: ['good'],
      overstocked: ['overstocked'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    category: { type: 'string_array', urlKey: 'category' },
    type: { type: 'string_array', urlKey: 'type' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: ['search', 'category', 'type']
}
